<script setup lang="ts">
    import { ref } from 'vue';
    import EchoButton from '../components/EchoButton.vue';
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import { __ } from '../stores/expressions';
    import SvgIcon from '../components/SvgIcon.vue';
    import CoachingFormList from '../components/coaching/CoachingFormList.vue';
    import { usePermissions } from '@/js/composables/usePermissions';
    import { PermissionArea, QualityAssuranceModulePermissionFlag } from '@/js/consts/permissions';
    import { PlusIcon } from '@lucide/vue';

    const { hasPermission } = usePermissions();

    const canCreateForm = hasPermission(
        PermissionArea.QualityAssuranceModule,
        QualityAssuranceModulePermissionFlag.CreateForm
    );

    const empty = ref<boolean>(false);
</script>
<template>
    <SettingsPageLayout fill-table>
        <template #header>
            <h1 class="heading-lg-light">{{ __('settings-manage-forms') }}</h1>
        </template>
        <template #topbar>
            <EchoButton v-if="canCreateForm" variant="primary" route="/settings/manage-forms/new">
                {{ __('manage-forms-add-new-form') }}
                <template #icon-right><PlusIcon /></template>
            </EchoButton>
        </template>
        <template #content>
            <template v-if="empty">
                <div class="w-full h-full flex justify-center items-center">
                    <div class="flex flex-col gap-4 items-center">
                        <span class="size-40">
                            <SvgIcon
                                name="sentiment-neutraltonegative-gray.svg"
                                class="stroke-transparent"
                            />
                        </span>
                        <h2 class="font-semibold text-2xl">
                            {{ __('manage-forms-empty-title') }}
                        </h2>
                        <EchoButton>
                            {{ __('manage-forms-empty-add-first') }}
                            <template #icon-right><PlusIcon /></template>
                        </EchoButton>
                    </div>
                </div>
            </template>
            <template v-else>
                <CoachingFormList />
            </template>
        </template>
    </SettingsPageLayout>
</template>
